<div class="ap-panel" [ngClass]="'ap-panel--'.concat(type())">
    <div class="ap-panel__header">
        @if (title()) {
            <h2 class="ap-panel__header--title" data-testid="title">{{ title() }}</h2>
        } @else {
            <ng-content select="[apPanelHeader]"></ng-content>
        }
    </div>
    <div class="ap-panel__body" data-testid="body">
        <ng-content select="[ap-panel-body]"></ng-content>
    </div>
</div>
